enum ResultType {
  Unknown = 0,
  Successful = 1,
  Error = 2,
  NegativeNominalRate = 3,
  IncorrectContractDate = 4,
  NegativePresentValue = 5
}

export default ResultType;
